export default __webpack_public_path__ + "static/feedback_avatar4-631b9e73bfac5ceea7bb836303d503da.webp";